import { createFileRoute } from '@tanstack/react-router';
import { AiOpsHealthPage } from '@/pages/super-admin/ai-ops/AiOpsHealthPage';
import { aiOpsWindowSearchSchema } from '@/pages/super-admin/ai-ops/ai-ops.constants';

export const Route = createFileRoute('/_authenticated/super-admin/ai-ops/')({
	component: AiOpsHealthPage,
	validateSearch: aiOpsWindowSearchSchema,
});
